module.exports = __webpack_public_path__ + "img/co-investing-5.211dec43.jpg";